export default function Matplotlib() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Matplotlib Component</h1>
      <p>This is the Matplotlib component.</p>
    </div>
  );
}